<div *ngIf="!showAgreement" class="thp-form-container">
  <form [formGroup]="r2rForm">
    <div class="field-group thp-form" *ngIf="isFromGather() ? clientVMSSubInfo.vmsSubGatherInfo.candidateValidationRequired && clientVMSSubInfo.dobRequired : clientVMSSubInfo.dobRequired">
      <div class="vms-header">
        <label class="field-label">{{"talent-happy-path.talent-vms.birthdate-verification" | translate}}</label>
        <p class="overline">{{"talent-happy-path.talent-vms.required" | translate}}</p>
      </div>

      <mat-form-field style="width: 100%"  *ngIf="dobOptionId === DobOptions.PARTIAL_DOB">
        <mat-label class="field-label">{{"talent-happy-path.talent-vms.birthdate-format" | translate}}</mat-label>
        <input matInput
               formControlName="birthDate"
               (input)="formatBirthDate()"
               maxlength="5"
               inputmode="numeric">
      </mat-form-field>
      <app-date-picker style="padding-top:rem-calc(20);" [(selectedDate)]="birthDate"
                         (selectedDateChange)="onBirthDateChange($event)"
                         [personId]="this.personId"
                         *ngIf="dobOptionId === DobOptions.FULL_DOB">
        </app-date-picker>

    </div>
    <div class="field-group thp-form" *ngIf="isFromGather() ? clientVMSSubInfo.vmsSubGatherInfo.candidateValidationRequired && clientVMSSubInfo.taxIdRequired : clientVMSSubInfo.taxIdRequired">
      <div class="vms-header">
        <label class="field-label">{{"talent-happy-path.talent-vms.tax-id" | translate}}</label>
        <p class="overline">{{"talent-happy-path.talent-vms.required" | translate}}</p>
      </div>
      <mat-form-field style="width: 100%">
        <mat-label class="field-label">
          {{"talent-happy-path.talent-vms.tax-id-format" | translate:{length: clientVMSSubInfo.taxIdLength} }}
        </mat-label>
        <input matInput
               [type]="showTaxId ? 'text' : 'password'"
               formControlName="taxIdDigits"
               [maxlength]="clientVMSSubInfo.taxIdLength"
               inputmode="numeric"
               (input)="formatTaxId()">
        <button matSuffix (click)="toggleTaxVisibility()" tabindex="-1">
          <mat-icon>{{ showTaxId ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
      </mat-form-field>
    </div>
  </form>
  <div [ngClass]="!showBackButton ? 'button-container' : 'button-container double-button-container'">
    <button id="vms-submittal-back-button"
            *ngIf="showBackButton" mat-button
            class="double-custom-button back-button"
            (click)="goToPreviousPage()">
      <mat-icon>arrow_back</mat-icon>{{ "talent-happy-path.buttons.back" | translate }}
    </button>
    <button id="vms-submittal-next-button"
            mat-button
            [ngClass]="!showBackButton ? 'custom-button single-custom-button' : 'custom-button double-custom-button next-button'"
            [disabled]="disableSubmit()"
            (click)="goToNextPage()">
      <mat-icon>arrow_forward</mat-icon>{{ "talent-happy-path.buttons.next" | translate }}
    </button>
  </div>
</div>
